import { jsxs, jsx } from 'react/jsx-runtime';
import { BubbleMenu, isTextSelection } from '@tiptap/react';
import { useState, useMemo } from 'react';
import Toolbar from '../ui/Toolbar/Toolbar.js';
import { modifyNodeItem, textFormattingGroup, aiGroup } from '../ui/Toolbar/toolbarConfig.js';
import { EMBED_RESOURCE_TYPE_NAME } from '../Extensions/EmbedResource/contants.js';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { createGlobalStyle, styled } from 'styled-components';
import { ContextualMenuPluginKey } from '../Extensions/ContextualMenu/ContextualMenuPlugin.js';

const InlineToolbar = ({ editor, contentRef }) => {
  const [bubbleRef, setBubbleRef] = useState(null);
  const toolbarGroups = useMemo(() => [
    {
      ...textFormattingGroup,
      items: [
        modifyNodeItem,
        ...textFormattingGroup.items
      ]
    },
    aiGroup
  ], []);
  const shouldShow = ({ view, state, from, to, editor: editor2 }) => {
    const contextualMenuState = ContextualMenuPluginKey.getState(view.state);
    if (editor2.isActive("embed") || editor2.isActive(EMBED_RESOURCE_TYPE_NAME) || editor2.isActive("emptyImage") || editor2.isActive("emptyFile") || editor2.isActive("horizontalRule") || contextualMenuState?.active) return false;
    const { doc, selection } = state;
    const { empty } = selection;
    const isEmptyTextBlock = !doc.textBetween(from, to).length && isTextSelection(state.selection);
    const isChildOfMenu = bubbleRef?.contains(document.activeElement);
    const hasEditorFocus = view.hasFocus() || isChildOfMenu;
    if (!hasEditorFocus || empty || isEmptyTextBlock || !editor2.isEditable) {
      return false;
    }
    return true;
  };
  const [isMouseDown, setIsMouseDown] = useState(false);
  useClientLayoutEffect(() => {
    const dom = editor.view.dom;
    if (!dom) return;
    const handleMouseDown = () => {
      setIsMouseDown(true);
    };
    const handleMouseUp = () => {
      setIsMouseDown(false);
    };
    dom.addEventListener("mousedown", handleMouseDown);
    dom.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("mouseup", handleMouseUp);
    document.addEventListener("blur", handleMouseUp);
    document.addEventListener("focusout", handleMouseUp);
    return () => {
      dom.removeEventListener("mousedown", handleMouseDown);
      dom.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("blur", handleMouseUp);
      document.removeEventListener("focusout", handleMouseUp);
    };
  }, [
    editor
  ]);
  return /* @__PURE__ */ jsxs(BubbleWrapper, {
    ref: setBubbleRef,
    children: [
      /* @__PURE__ */ jsx(TippyRootPointerEvents, {}),
      /* @__PURE__ */ jsx(BubbleMenu, {
        className: "tiptap-inline-toolbar",
        editor,
        shouldShow,
        tippyOptions: {
          duration: 0,
          delay: 250,
          popperOptions: {
            modifiers: [
              {
                name: "offset",
                enabled: true,
                options: {
                  offset: [
                    0,
                    10
                  ]
                }
              },
              {
                name: "flip",
                enabled: true,
                options: {
                  fallbackPlacements: [
                    "top",
                    "bottom"
                  ],
                  boundary: contentRef ?? void 0
                }
              }
            ]
          }
        },
        children: /* @__PURE__ */ jsx(ToolbarWrapper, {
          "data-is-mouse-down": isMouseDown,
          "data-inline-toolbar-wrapper": true,
          children: /* @__PURE__ */ jsx(Toolbar, {
            editor,
            groups: toolbarGroups,
            floating: true
          })
        })
      })
    ]
  });
};
const TippyRootPointerEvents = createGlobalStyle([
  `[data-tippy-root]:has([data-inline-toolbar-wrapper][data-is-mouse-down='true']){pointer-events:none;z-index:-1 !important;}`
]);
const ToolbarWrapper = styled.div.withConfig({
  displayName: "InlineToolbar__ToolbarWrapper",
  componentId: "sc-e799dfe2-0"
})([
  `transition:opacity 0.2s ease-in-out;opacity:1;&[data-is-mouse-down='true']{pointer-events:none;opacity:0;position:absolute;}`
]);
const BubbleWrapper = styled.div.withConfig({
  displayName: "InlineToolbar__BubbleWrapper",
  componentId: "sc-e799dfe2-1"
})([
  `position:absolute;`
]);

export { InlineToolbar as default };
//# sourceMappingURL=InlineToolbar.js.map
